// App
import React from 'react';

// Misc / utils
import * as S from './styles';

// Misc / utils
import HomeMarker from '../images/icons/homeMarker.inline.svg';

type HomeDotPropTypes = {
  northSouthLat: number | null;
  eastWestLng: number | null;
  onMapMarkerMouseEnter: () => void;
  onMapMarkerMouseLeave: () => void;
  onMarkerClick: () => void;
};

const HomeDot = ({
  northSouthLat,
  eastWestLng,
  onMapMarkerMouseEnter,
  onMapMarkerMouseLeave,
  onMarkerClick,
}: HomeDotPropTypes) => {
  return (
    <S.HomeDot
      northSouthLat={northSouthLat}
      eastWestLng={eastWestLng}
      onMouseEnter={onMapMarkerMouseEnter}
      onMouseLeave={onMapMarkerMouseLeave}
      onClick={onMarkerClick}
    >
      <HomeMarker width="30" height="30" />
    </S.HomeDot>
  );
};

export default HomeDot;
